import Vue from 'vue';
import VueRouter from 'vue-router';
import { VueMaskDirective } from 'v-mask';
import store from './store';
import SubscriptionsManager from '@/helpers/subscriptionsManager';
import router from './router';
import Layout from './components/Layout';
import closable from './modules/closable';
import './validator';
import VTooltip from 'v-tooltip';
import VueScrollTo from 'vue-scrollto';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/hu';
import 'vue2-datepicker/index.css';

import CalcElem from '@/components/CalcElem';
import InputField from '@/components/InputField';
import '@/helpers/filters';
import instances from '../helpers/app';
import StateBar from "@/components/StateBar.vue";

require('../bootstrap');

closable();

Vue.use(VueScrollTo);
Vue.use(VueRouter);
Vue.use(VTooltip, {
	defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click',
});

Vue.directive('mask', VueMaskDirective);

Vue.component('CalcElem', CalcElem);
Vue.component('InputField', InputField);
Vue.component('DatePicker', DatePicker);
Vue.component('StateBar', StateBar);

let SubMan = new SubscriptionsManager(store, router);
store.subscribe((mutation, state) => {
	SubMan.resolve(mutation, state);
});

Vue.prototype.$instances = instances;

new Vue({
	el: '#calculator',
	render: h => h(Layout),
	store,
	router,
});
